<div class="container margin-top-20">
  <div class="row">
    <div class="col-md-4 col-md-offset-4">
      <div class="my-account style-1 margin-top-5 margin-bottom-40">
        <ul class="tabs-nav">
          <!-- <li><a [routerLink]="'/login-register'">Log In</a></li>
          <li class="active"><a [routerLink]="'/registration'">Register</a></li> -->
        </ul>
        <div class="tabs-container alt">
          <div class="tab-content" id="tab2">
            <!-- <form class="register" (ngSubmit)="Register()" #userForm="ngForm">
              <div class="row margin-bottom-10">
                <div class="col-md-12">
                  <div class="form-group" [class.has-error]="firstNameControl.invalid && firstNameControl.touched"
                    [class.has-success]="firstNameControl.valid">
                    <label for="FirstName" class="control-label"> First Name:<i class="fa fa-asterisk"></i></label>
                    <input type="text" maxlength="35" class="input-text" name="FirstName" [(ngModel)]="Registration.FirstName"
                      id="FirstName" value="" required #firstNameControl="ngModel" />
                    <div class="notification error" *ngIf="firstNameControl.invalid && firstNameControl.touched">
                      <p>First name field is required</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-bottom-10">
                <div class="col-md-12">
                  <div class="form-group" [class.has-error]="userLastNameControl.invalid && userLastNameControl.touched"
                    [class.has-success]="userLastNameControl.valid">
                    <label for="LastName" class="control-label"> Last Name:<i class="fa fa-asterisk"></i></label>
                    <input type="text" maxlength="35" class="input-text" name="LastName" [(ngModel)]="Registration.LastName"
                      id="LastName" value="" required #userLastNameControl="ngModel" />
                    <div class="notification error" *ngIf="userLastNameControl.invalid && userLastNameControl.touched">
                      <p>Last name field is required</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-bottom-10">
                <div class="col-md-12">
                  <div class="form-group" [class.has-error]="userNameControl.invalid && userNameControl.touched"
                    [class.has-success]="userNameControl.valid">
                    <label for="RegUserName" class="control-label"> User Name:<i class="fa fa-asterisk"></i></label>
                    <input type="text" maxlength="35" class="input-text" [(ngModel)]="Registration.RegUserName"
                      (focusout)="UserNamefocusOut($event.target.value)" name="RegUserName" id="RegUserName" value=""
                      #userNameControl="ngModel" required />
                    <div class="notification error" *ngIf="userNameControl.invalid && userNameControl.touched">
                      <p>User name field is required</p>
                    </div>
                    <div *ngIf="UserNameTakenError" class="notification error closeable">
                      <p>User name is already taken, Please try different one</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-bottom-10">
                <div class="col-md-12">
                  <div class="form-group" [class.has-error]="emailControl.invalid && emailControl.touched"
                    [class.has-success]="emailControl.valid">
                    <label for="RegEmail" class="control-label"> Email Address:<i class="fa fa-asterisk"></i></label>
                    <input type="text" maxlength="100" class="input-text" [(ngModel)]="Registration.RegEmail"
                      (focusout)="UserEmailfocusOut($event.target.value)" name="RegEmail" id="RegEmail" value=""
                      [pattern]="emailPattern" #emailControl="ngModel" required />
                    <div class="notification error" *ngIf="emailControl.invalid && emailControl.touched">
                      <p>Email address field is required</p>
                    </div>
                    <div *ngIf="emailControl.errors?.pattern" class="notification error">
                      <p>Email address is not valid</p>
                    </div>
                    <div *ngIf="UserEmailTakenError" class="notification error">
                      <p>Email address is already registered, please try to login</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-bottom-10">
                <div class="col-md-12">
                  <div class="form-group" [class.has-error]="passwordControl.invalid && passwordControl.touched"
                    [class.has-success]="passwordControl.valid">
                    <label for="RegPassword" class="control-label">Password:<i class="fa fa-asterisk"></i></label>
                    <input class="input-text" maxlength="35" type="password" [(ngModel)]="Registration.RegPassword" name="RegPassword"
                      id="RegPassword" required #passwordControl="ngModel" minlength="8" />
                    <div class="notification error" *ngIf="passwordControl.invalid && !passwordControl.errors?.minlength && passwordControl.touched">
                      <p>Password field is required</p>
                    </div>
                    <div *ngIf="passwordControl.errors?.minlength && passwordControl.touched " class="notification error">
                      <p>Password must be at least 8 characters long</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group"
                    [class.has-error]="repeatPasswordControl.invalid && repeatPasswordControl.touched"
                    [class.has-success]="repeatPasswordControl.valid">
                    <label for="RegConfirmPassword" class="control-label">Confirm Password:<i
                        class="fa fa-asterisk"></i></label>
                    <input class="input-text" maxlength="35" type="password" [(ngModel)]="Registration.RegConfirmPassword"
                      name="RegConfirmPassword" id="RegConfirmPassword" required #repeatPasswordControl="ngModel"
                      (focusout)="ConfirmPassword();" />
                    <div class="notification error"
                      *ngIf="repeatPasswordControl.invalid && repeatPasswordControl.touched">
                      <p>Confirm password field is required</p>
                    </div>
                    <div class="notification error" *ngIf="PasswordDontMatch">
                      <p>Confirm password didn't match</p>
                    </div>
                  </div>
                </div>
              </div>
              <input type="submit" class="submit button margin-top-20" id="submit" value="Register"
                [disabled]="userForm.invalid || !IsFormValid" />
            </form> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
